module.exports = __webpack_public_path__ + "img/fb917f8c21ee5d28bd3432ad61f6313e.png";